/* Aurelius product page: gallery, add-on totals, add-to-cart with grouped line items */
(function () {
  const root = document.querySelector('[data-aur-buy]'); if (!root) return;
  // Sold out: back-in-stock signup to Klaviyo (client API, public key only)
  const notify = root.querySelector('[data-aur-notify]');
  if (notify) notify.addEventListener('submit', async (e) => {
    e.preventDefault();
    const input = notify.querySelector('input[type=email]'); const btn = notify.querySelector('button[type=submit]');
    const msg = notify.querySelector('[data-aur-notify-msg]'); const email = input.value.trim();
    msg.classList.remove('is-error');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { msg.textContent = 'Please enter a valid email address.'; msg.classList.add('is-error'); input.focus(); return; }
    btn.disabled = true; btn.textContent = 'Sending…';
    try {
      const r = await fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(notify.dataset.company), {
        method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' },
        body: JSON.stringify({ data: { type: 'back-in-stock-subscription',
          attributes: { profile: { data: { type: 'profile', attributes: { email } } }, channels: ['EMAIL'] },
          relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + notify.dataset.variantId } } } } })
      });
      if (!r.ok) throw new Error(await r.text());
      notify.querySelector('.aur-notify__row').hidden = true;
      msg.textContent = "You're on the list. We'll email " + email + " as soon as it's back.";
    } catch (err) {
      console.error(err); btn.disabled = false; btn.textContent = 'Notify me';
      msg.textContent = "Sorry, that didn't go through. Please try again."; msg.classList.add('is-error');
    }
  });
  if (!root.querySelector('[data-aur-add]')) return;
  const money = (cents) => {
    const cur = root.dataset.currency || 'AUD';
    return new Intl.NumberFormat('en-AU', { style: 'currency', currency: cur, minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(cents / 100);
  };
  // Gallery thumbs -> main
  const main = root.querySelector('[data-aur-main] img');
  root.querySelectorAll('[data-aur-thumb]').forEach(btn => btn.addEventListener('click', () => {
    if (main) { main.src = btn.dataset.aurThumb; main.srcset = ''; }
    root.querySelectorAll('[data-aur-thumb]').forEach(b => b.removeAttribute('aria-current')); btn.setAttribute('aria-current', 'true');
  }));
  // Add-on options
  root.querySelectorAll('[data-aur-addon]').forEach(item => {
    const check = item.querySelector('[data-aur-addon-check]');
    const priceEl = item.querySelector('[data-aur-addon-price]');
    item.querySelectorAll('[data-aur-opt]').forEach(opt => opt.addEventListener('click', () => {
      item.querySelectorAll('[data-aur-opt]').forEach(o => o.setAttribute('aria-pressed', 'false'));
      opt.setAttribute('aria-pressed', 'true');
      check.dataset.variantId = opt.dataset.variantId; check.dataset.price = opt.dataset.price;
      if (priceEl) priceEl.textContent = money(+opt.dataset.price);
      const sku = item.querySelector('.aur-set__sku'); if (sku && opt.dataset.sku) sku.textContent = 'SKU ' + opt.dataset.sku;
      recalc();
    }));
    check.addEventListener('change', recalc);
    const ini = item.querySelector('[data-aur-initials]');
    if (ini) ini.addEventListener('input', () => { ini.value = ini.value.replace(/[^A-Za-z]/g, '').toUpperCase().slice(0, 3); });
  });
  function selected() {
    return [...root.querySelectorAll('[data-aur-addon-check]:checked')].map(c => {
      const item = c.closest('[data-aur-addon]');
      const ini = item.querySelector('[data-aur-initials]');
      return { id: +c.dataset.variantId, price: +c.dataset.price, initials: ini ? ini.value : '', label: item.querySelector('.aur-set__txt span').textContent.trim() };
    });
  }
  function recalc() {
    const base = +root.dataset.basePrice; const adds = selected();
    const total = base + adds.reduce((s, a) => s + a.price, 0);
    root.querySelector('[data-aur-total]').textContent = money(total);
    root.querySelector('[data-aur-total-btn]') && (root.querySelector('[data-aur-total-btn]').textContent = money(total));
    root.querySelector('[data-aur-total-ap]').textContent = money(Math.round(total / 4));
    const lbl = root.querySelector('[data-aur-total-label]');
    lbl.textContent = lbl.textContent.split(' + ')[0] + (adds.length ? ' + ' + adds.map(a => a.label.toLowerCase()).join(', ') : '');
  }
  recalc();
  // Add to cart: parent first, then add-ons with properties grouping them
  root.querySelector('[data-aur-add]').addEventListener('click', async (e) => {
    const btn = e.currentTarget; btn.disabled = true; const orig = btn.innerHTML; btn.textContent = 'Adding…';
    const group = 'aur-' + Date.now();
    const items = [{ id: +root.dataset.variantId, quantity: 1, properties: { _bundle_group: group } }];
    for (const a of selected()) {
      const props = { _bundle_group: group, _bundle_parent: root.dataset.variantId };
      if (a.initials) props['Initials'] = a.initials;
      items.push({ id: a.id, quantity: 1, properties: props });
    }
    const tagNeedsInitials = selected().some(a => a.initials === '' && root.querySelector(`[data-aur-addon-check][data-variant-id="${a.id}"]`)?.closest('[data-aur-addon]')?.dataset.initials === 'true');
    if (tagNeedsInitials) { btn.disabled = false; btn.innerHTML = orig; alert('Please enter the initials for your luggage tag.'); return; }
    try {
      const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
      if (!r.ok) throw new Error(await r.text());
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      window.location.href = '/cart';
    } catch (err) { console.error(err); btn.disabled = false; btn.innerHTML = orig; alert('Sorry — that didn\'t add. Please try again.'); }
  });
})();
